import { render, staticRenderFns } from "./carDetailDialog.vue?vue&type=template&id=22caa263&"
import script from "./carDetailDialog.vue?vue&type=script&lang=js&"
export * from "./carDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports